import React from "react";
import { FiPhoneCall } from "react-icons/fi";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../redux/userSlice";
export default function PhoneDirectChatIcon() {
  const userInfo = useSelector(selectUserInfo);

  // Only show for non‑admin roles
  if (userInfo?.data?.role === 1) return null;
  return (
    <a
      href="tel:+14162943015"
      style={{
        position: "fixed",
        bottom: "140px", // keep above WhatsApp if both are shown
        right: "27px",
        zIndex: 9,
        backgroundColor: "#0a66c2",
        color: "white",
        borderRadius: "50%",
        padding: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        textDecoration: "none",
      }}
    >
      <FiPhoneCall size={25} />
    </a>
  );
}
